<template>
  <div class="exam-form">
    <div class="exam-item" v-for="(item,index) in list" :key="index">
      <div class="exam-label">
        {{item.content}}
      </div>
      <div v-if="!isResult">
        <template v-if="item.type=='单选'">
          <van-radio-group v-model="item.value" :icon-size="16" :checked-color="themeColor" @change="change">
            <van-radio v-for="(oitem, oindex) in item.options" :key="oindex" :name="oitem">{{oitem}}</van-radio>
          </van-radio-group>
        </template>
        <template v-if="item.type=='多选'">
          <van-checkbox-group v-model="item.value" :icon-size="16" :checked-color="themeColor" @change="change">
            <van-checkbox v-for="(oitem, oindex) in item.options" :key="oindex" :name="oitem">{{oitem}}</van-checkbox>
          </van-checkbox-group>
        </template>
      </div>
      <div v-if="isResult" class="result-group">
        <div class="result-item" v-for="(ritem, rindex) in item.options" :key="rindex">
          <div v-if="showAnswer" class="result-icon">
            <template v-if="isChecked(ritem,item.value) || isAnswer(ritem,item.answer)">
              <van-icon v-if="isError(ritem, item.value, item.answer)" name="clear" color="#ff0000" size="18" />
              <van-icon v-else-if="item.type=='多选' && isMissedError(ritem, item.value, item.answer)" name="checked" color="#ff0000" size="18" />
              <van-icon v-else name="checked" :color="themeColor" size="18" />
            </template>
          </div>
          <div v-else class="result-icon">
            <template v-if="isChecked(ritem,item.value)">
              <van-icon v-if="isError(ritem, item.value, item.answer)" name="clear" color="#ff0000" size="18" />
              <van-icon v-else-if="item.type=='多选' && isMissedError(ritem, item.value, item.answer)" name="checked" color="#ff0000" size="18" />
              <van-icon v-else name="checked" :color="themeColor" size="18" />
            </template>
          </div>
          <div class="result-label">{{ritem}}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import {
    Toast
  } from "vant";

  export default {
    name: 'examForm',
    props: {
      arr: {
        type: Array,
        default: () => []
      },
    },
    computed: {
      list() {
        return this.arr
      },
    },
    data() {
      return {
        themeColor: this.themeColor,
        isResult: false,
        showAnswer: false,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      async init() {},
      isChecked(item,value) {
        let res = false
        if (Array.isArray(value)) {
          if (value.indexOf(item) != -1) res = true
        } else if (item==value) {
          res = true
        }
        return res
      },
      isAnswer(item, answer) {
        let res = false
        if (answer.indexOf(item) != -1) res = true
        return res
      },
      isError(item, value, answer) {
        let ischecked = this.isChecked(item,value)
        let isanswer = this.isAnswer(item, answer)
        if (ischecked && !isanswer) {
          return true
        } else {
          return false
        }
      },
      isMissedError(item, value, answer) {
        let ischecked = this.isChecked(item,value)
        let isanswer = this.isAnswer(item, answer)
        if (!ischecked && isanswer) {
          return true
        } else {
          return false
        }
      },
      change(e) {
        console.log('radioChange', e, this.list)
      },
    }
  }
</script>

<style lang="less">
.exam-form {
  color: #333;
  .exam-item {
    margin-bottom: 20px;
    .exam-label {
      font-size: 15px; margin-bottom: 5px;
    }
    .van-checkbox,.van-radio {
      font-size: 15px; padding: 2px 0;
    }
    .van-checkbox__label,.van-radio__label {
      color: #666;
    }
  }
  .result-group {
    .result-item {
      font-size: 15px; color: #787878; padding: 2px 0; display: flex; align-items: center;
    }
    .result-icon {
      width: 18px; margin-left: -1px;
      .van-icon {
        display: block;
      }
    }
    .result-label {
      line-height: 20px; margin-left: 8px; color: #787878;
    }
  }
}
</style>